import { defineComponent as x, useTemplateRef as S, computed as v, toRefs as T, getCurrentInstance as $, onMounted as O, createElementBlock as g, openBlock as h, mergeProps as V, unref as e, createElementVNode as A, createCommentVNode as U, normalizeClass as K, createVNode as M } from "vue";
import o from "../node_modules/.pnpm/@patternfly_react-styles@6.2.2/node_modules/@patternfly/react-styles/css/components/FormControl/form-control.js";
import { useInputValidation as N } from "../input.js";
import { useChildrenTracker as I } from "../use/children-tracker.js";
import { FormInputsKey as W, FormGroupInputsKey as F } from "./Form/common.js";
import { useOUIAProps as q } from "../helpers/ouia.js";
import D from "./FormControlIcon.vue2.js";
const G = ["value", "disabled", "readonly", "aria-invalid"], _ = /* @__PURE__ */ x({
  name: "PfTextarea",
  inheritAttrs: !1,
  __name: "Textarea",
  props: {
    disabled: { type: Boolean },
    readonly: { type: Boolean },
    readonlyVariant: {},
    autoResize: { type: Boolean },
    resizeOrientation: { default: "both" },
    pattern: {},
    modelValue: { default: void 0 },
    modelModifiers: {},
    validated: {},
    autoValidate: { type: [String, Boolean], default: !0 },
    maxHeight: {},
    maxWidth: {},
    ouiaId: {},
    ouiaSafe: { type: Boolean }
  },
  emits: ["change", "blur", "input", "invalid", "keyup", "update:modelValue", "update:validated"],
  setup(C, { expose: b }) {
    var c;
    const i = C, z = q({ id: i.ouiaId, safe: i.ouiaSafe }), r = S("inputRef"), P = v(() => ["success", "error", "warning"].includes(l.value)), { validated: B } = T(i), {
      value: s,
      effectiveValidated: l,
      onBlur: d,
      onChange: k,
      onInput: R,
      onInvalid: p,
      onKeyUp: m,
      ...u
    } = N({
      inputElement: r,
      autoValidate: i.autoValidate,
      validated: B,
      customCheckValidity: f
    });
    I(W, (c = $()) == null ? void 0 : c.proxy), I(F, l);
    const w = v(() => i.pattern instanceof RegExp ? i.pattern : new RegExp(`^(?:${i.pattern})$`, "us"));
    function f() {
      if (!r.value)
        return !1;
      if (u.setCustomValidity(""), i.pattern && s.value && !w.value.test(String(s.value))) {
        let a = "Please match the format requested.";
        return r.value.title && (a += `
${r.value.title}`), u.setCustomValidity(a), !1;
      }
      return HTMLTextAreaElement.prototype.checkValidity.call(r.value) ? (u.innerValidated.value = "success", !0) : !1;
    }
    function E(t) {
      i.autoResize && y(), k(t);
    }
    function y() {
      if (!r.value)
        return !1;
      const t = r.value.parentElement;
      if (!t)
        return;
      t.style.setProperty("height", "inherit");
      const a = window.getComputedStyle(r.value), n = parseInt(a.getPropertyValue("border-top-width")) + parseInt(a.getPropertyValue("padding-top")) + r.value.scrollHeight + parseInt(a.getPropertyValue("padding-bottom")) + parseInt(a.getPropertyValue("border-bottom-width"));
      t.style.setProperty("height", `${n}px`);
    }
    O(() => {
      i.autoResize && y();
    });
    function H() {
      var t;
      (t = r.value) == null || t.focus();
    }
    return b({
      ...u,
      input: r,
      focus: H,
      value: s,
      checkValidity: f
    }), (t, a) => (h(), g("span", V(e(z), {
      class: [
        e(o).formControl,
        {
          [e(o).modifiers.readonly]: !!t.readonlyVariant,
          [e(o).modifiers.plain]: t.readonlyVariant === "plain",
          [e(o).modifiers.disabled]: t.disabled,
          [e(o).modifiers.resizeVertical]: t.resizeOrientation === "vertical",
          [e(o).modifiers.resizeHorizontal]: t.resizeOrientation === "horizontal",
          [e(o).modifiers.resizeBoth]: t.resizeOrientation === "both",
          [e(o).modifiers.success]: e(l) === "success",
          [e(o).modifiers.warning]: e(l) === "warning",
          [e(o).modifiers.error]: e(l) === "error"
        }
      ],
      style: {
        maxHeight: t.maxHeight,
        maxWidth: t.maxWidth
      }
    }), [
      A("textarea", V({
        ref: "inputRef",
        value: e(s)
      }, t.$attrs, {
        disabled: t.disabled || void 0,
        readonly: !!t.readonlyVariant || t.readonly,
        "aria-invalid": e(l) === "error",
        onChange: E,
        onInput: a[0] || (a[0] = (n) => e(R)(n)),
        onBlur: a[1] || (a[1] = //@ts-ignore
        (...n) => e(d) && e(d)(...n)),
        onInvalid: a[2] || (a[2] = //@ts-ignore
        (...n) => e(p) && e(p)(...n)),
        "on:keyUp": a[3] || (a[3] = //@ts-ignore
        (...n) => e(m) && e(m)(...n))
      }), null, 16, G),
      P.value ? (h(), g("span", {
        key: 0,
        class: K(e(o).formControlUtilities)
      }, [
        M(D, {
          status: e(l)
        }, null, 8, ["status"])
      ], 2)) : U("", !0)
    ], 16));
  }
});
export {
  _ as default
};
